import { render, staticRenderFns } from "./lahanUmumMonitoringDetail.vue?vue&type=template&id=3dca4bb6"
import script from "./lahanUmumMonitoringDetail.vue?vue&type=script&lang=js"
export * from "./lahanUmumMonitoringDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports